import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

export const getToken = () => localStorage.getItem("tro_token");
export const setToken = (t) => (t ? localStorage.setItem("tro_token", t) : localStorage.removeItem("tro_token"));

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  cfg.headers["X-Device-Id"] = getDeviceId();
  return cfg;
});

export function getDeviceId() {
  let d = localStorage.getItem("tro_device_id");
  if (!d) {
    d = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("tro_device_id", d);
  }
  return d;
}

export function deviceLabel() {
  const ua = navigator.userAgent;
  const os = /iPhone/.test(ua) ? "iPhone" : /iPad|Macintosh.*Mobile/.test(ua) ? "iPad" : /Android/.test(ua) ? "Android" : /Mac/.test(ua) ? "Mac" : /Windows/.test(ua) ? "Windows PC" : /CrOS/.test(ua) ? "Chromebook" : /Linux/.test(ua) ? "Linux PC" : "Device";
  const br = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Safari\//.test(ua) ? "Safari" : /Firefox\//.test(ua) ? "Firefox" : "Browser";
  return `${os} · ${br} · ${getDeviceId().slice(0, 4).toUpperCase()}`;
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const imgUrl = (src) => (!src ? null : src.startsWith("/api/") ? `${BACKEND}${src}` : src);

export async function downloadFile(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const wsUrl = (params) => `${BACKEND.replace(/^http/, "ws")}/api/ws?token=${getToken()}${params ? `&${params}` : ""}`;

export const safeRedirect = (r) => (r && r.startsWith("/") && !r.startsWith("//") ? r : null);

export const fmtClock = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(Math.floor(s % 60)).padStart(2, "0")}`;
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "");
export const label = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
export const cid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

export async function uploadTeamLogo(teamId, file, onProgress) {
  let uploadId;
  let phase = "Start upload";
  const base = `/teams/${teamId}/logo/uploads`;
  try {
    onProgress({ percent: 0, label: "Preparing upload…" });
    const { data: upload } = await api.post(base, { filename: file.name, size: file.size, content_type: file.type });
    uploadId = upload.upload_id;
    for (let index = 0; index < upload.chunk_count; index++) {
      const offset = index * upload.chunk_size;
      const chunk = file.slice(offset, Math.min(offset + upload.chunk_size, file.size));
      phase = `Upload part ${index + 1} of ${upload.chunk_count}`;
      await api.put(`${base}/${uploadId}/chunks/${index}`, chunk, {
        headers: { "Content-Type": "application/octet-stream" },
        onUploadProgress: ({ loaded }) => onProgress({ percent: Math.round((offset + Math.min(loaded, chunk.size)) / file.size * 90), label: phase }),
      });
    }
    phase = "Validate and save logo";
    onProgress({ percent: 95, label: "Validating and saving logo…" });
    const { data } = await api.post(`${base}/${uploadId}/complete`);
    onProgress({ percent: 100, label: "Logo saved" });
    return data;
  } catch (error) {
    if (uploadId) await api.delete(`${base}/${uploadId}`).catch(() => {});
    throw new Error(`${phase}: ${errMsg(error)}`);
  }
}

